import type { FC } from "react";
import type { SelectChangeEvent } from "@mui/material";

import { RulesTabHeurekaCase } from "./rulesTabCases/RulesTabHeurekaCase";
import { RulesTabActualVisitorsCase } from "./rulesTabCases/RulesTabActualVisitorsCase";
import { RulesTabShoptetCouponCode } from "./rulesTabCases/RulesTabShoptetCouponCode";
import { RulesTabLastOrdersRegistrationTab } from "./rulesTabCases/RulesTabLastOrdersRegistrationTab";
import { RulesTabShoptetLastOrdersCase } from "./rulesTabCases/RulesTabShoptetLastOrdersCase";
import { RulesTabSummaryModalCase } from "./rulesTabCases/RulesTabSummaryModalCase";
import { RulesTabZboziCase } from "./rulesTabCases/RulesTabZboziCase";

type RulesType =
  | "lastOrders"
  | "lastRegistrations"
  | "heureka"
  | "actualVisitors"
  | "shoptetCouponCode"
  | "shoptetLastOrders"
  | "shopifyLastOrders"
  | "eshopRychleLastOrders"
  | "summaryModal"
  | "zbozi";

interface NotificationRulesTabProps {
  rulesType: RulesType;
  forOrders?: boolean;
  max?: number;
  min?: number;
  days?: number;
  minReviewStars?: number;
  minReviews?: number;
  minNumberOfVisitors?: number;
  withRepeat: boolean;
  selectedVariant?: string;
  dropdownTimeRanges?: { title: string; value: string }[];
  selectedTimeRange?: string;
  onChangeMax?: (value: number) => void;
  onChangeMin?: (value: number) => void;
  onChangeDays?: (value: number) => void;
  onChangeMinReviewStars?: (value: number) => void;
  onChangeMinReviews?: (value: number) => void;
  onChangeMinNumberOfVisitors?: (value: number) => void;
  onToggleWithRepeat: () => void;
  onChangeTimeRange?: (value: string) => void;
  onDaysChange?: (event: SelectChangeEvent) => void;
  t: (key: string) => string;
}

export const NotificationRulesTab: FC<NotificationRulesTabProps> = ({
  rulesType,
  forOrders,
  max,
  min,
  days,
  minReviewStars,
  minReviews,
  minNumberOfVisitors,
  withRepeat,
  selectedVariant,
  dropdownTimeRanges,
  selectedTimeRange,
  onChangeMax,
  onChangeMin,
  onChangeDays,
  onChangeMinReviewStars,
  onChangeMinReviews,
  onChangeMinNumberOfVisitors,
  onToggleWithRepeat,
  onChangeTimeRange,
}) => {
  switch (rulesType) {
    case "lastOrders":
    case "lastRegistrations":
      return (
        <RulesTabLastOrdersRegistrationTab
          onToggleWithRepeat={onToggleWithRepeat}
          withRepeat={withRepeat}
          days={days}
          forOrders={forOrders}
          max={max}
          min={min}
          onChangeDays={onChangeDays}
          onChangeMax={onChangeMax}
          onChangeMin={onChangeMin}
        />
      );
    case "heureka":
      return (
        <RulesTabHeurekaCase
          onToggleWithRepeat={onToggleWithRepeat}
          withRepeat={withRepeat}
          minReviewStars={minReviewStars}
          minReviews={minReviews}
          onChangeMinReviewStars={onChangeMinReviewStars}
          onChangeMinReviews={onChangeMinReviews}
        />
      );
    case "actualVisitors":
      return (
        <RulesTabActualVisitorsCase
          onToggleWithRepeat={onToggleWithRepeat}
          withRepeat={withRepeat}
          minNumberOfVisitors={minNumberOfVisitors}
          onChangeMinNumberOfVisitors={onChangeMinNumberOfVisitors}
        />
      );
    case "shoptetCouponCode":
      return (
        <RulesTabShoptetCouponCode
          onToggleWithRepeat={onToggleWithRepeat}
          withRepeat={withRepeat}
        />
      );
    case "shoptetLastOrders":
    case "shopifyLastOrders":
    case "eshopRychleLastOrders":
      return (
        <RulesTabShoptetLastOrdersCase
          onToggleWithRepeat={onToggleWithRepeat}
          withRepeat={withRepeat}
          dropdownTimeRanges={dropdownTimeRanges}
          onChangeTimeRange={onChangeTimeRange}
          selectedTimeRange={selectedTimeRange}
        />
      );
    case "summaryModal":
      return (
        <RulesTabSummaryModalCase
          onToggleWithRepeat={onToggleWithRepeat}
          withRepeat={withRepeat}
          days={days}
          min={min}
          onChangeDays={onChangeDays}
          onChangeMin={onChangeMin}
          selectedVariant={selectedVariant}
        />
      );
    case "zbozi": {
      return (
        <RulesTabZboziCase
          onToggleWithRepeat={onToggleWithRepeat}
          withRepeat={withRepeat}
          minReviewStars={minReviewStars}
          minReviews={minReviews}
          onChangeMinReviewStars={onChangeMinReviewStars}
          onChangeMinReviews={onChangeMinReviews}
          selectedVariant={selectedVariant}
        />
      );
    }
    default:
      return null;
  }
};
